import createIcon from '../../createIcon';

/**
 * @component @name SubdirectoryArrowRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuNSAxNC41TDEzLjUgMjAuNUwxMi4wOCAxOS4wOEwxNS42NyAxNS41SDQuNVYzLjVINi41VjEzLjVIMTUuNjdMMTIuMDggOS45MkwxMy41IDguNUwxOS41IDE0LjVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SubdirectoryArrowRight = createIcon('SubdirectoryArrowRight', [
  [
    'path',
    {
      d: 'M19.5 14.5L13.5 20.5L12.08 19.08L15.67 15.5H4.5V3.5H6.5V13.5H15.67L12.08 9.92L13.5 8.5L19.5 14.5Z',
      key: 'va4lmn',
    },
  ],
]);

export default SubdirectoryArrowRight;
